import { getBusinessObjectives } from 'pricing-pages-lib/api/BusinessObjectiveApi';
import { BUSINESS_OBJECTIVES } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
export const FetchBusinessObjectivesRequestTypes = createRequestTypes(BUSINESS_OBJECTIVES);
export const FetchBusinessObjectivesActions = createRequestActions(FetchBusinessObjectivesRequestTypes);
export const fetchBusinessObjectives = ({
  highlightedProducts,
  highlightedFeatureType
}) => {
  return makeFetchRequest({
    requestActions: FetchBusinessObjectivesActions,
    fetch: getBusinessObjectives,
    payload: {
      highlightedProducts,
      highlightedFeatureType
    }
  });
};